const CircularLoading = () => {
    return (
        <div
            className="w-[20px] aspect-square rounded-full border-[5px] border-gray-200 border-r-rounded border-r-z-dark-moss-green"
            style={{
                animation: "slow-spin 3s linear infinite",
            }}
        />
    );
};

export { CircularLoading };